/**
 * エラーメッセージ・スタックトレースから認証情報をマスキングする。
 *
 * 依存ゼロの独立モジュールにしている理由: instrumentation.ts（onRequestError）は
 * middleware エラー時に Edge ランタイムで実行されるため、axios / supabase を
 * 引き込む report-error.ts をそこから import すると Edge でクラッシュし得る。
 * ブラウザ側（report-error.ts）とサーバー側（slack-error-notifier.ts）の
 * 両方がここから import する。
 */

// 受験用の符号（招待トークン・共通リンクの符号など）はパス内に置かれ、符号だけで
// 面接の開始と回答送信ができる持参型の資格情報になる。Slack 通知・CloudWatch に
// 平文で残ると受験を乗っ取れるため、経路の接頭辞に続く 1 区間を伏せ字にする（#1767）。
// 接頭辞は長いものから順に並べる（/interview/line/c/... を /interview/line/... より
// 先に判定させるため）。区間長を 16 文字以上に限定して、/interview/feedback/12 の
// ような符号でない経路を書き換えないようにしている。
// backend/app/controllers/api/v1/client_errors_controller.rb の
// INTERVIEW_SECRET_PATH_PATTERN と対になっているため、片方を変える際は両方を揃える。
const INTERVIEW_SECRET_PATH_PATTERN =
  /(\/(?:interview-demo|interview)\/(?:line\/c\/|line\/|link\/|mypage\/)?)[A-Za-z0-9_-]{16,}/g;

export function redact(input: string): string {
  return input
    .replace(/access_token=[^&\s"']*/g, "access_token=REDACTED")
    .replace(/id_token=[^&\s"']*/g, "id_token=REDACTED")
    .replace(/Bearer [A-Za-z0-9_.\-]+/g, "Bearer REDACTED")
    .replace(
      /eyJ[A-Za-z0-9_-]{20,}\.[A-Za-z0-9_-]{6,}\.[A-Za-z0-9_-]{6,}/g,
      "JWT_REDACTED",
    )
    .replace(INTERVIEW_SECRET_PATH_PATTERN, "$1REDACTED");
}
